import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineLoading } from "react-icons/ai";
import { GoAlertFill } from "react-icons/go";
import { Button } from "flowbite-react";
import useLogin from "../hooks/useLogin";
import { checkIfAuthenticated } from "../utils/utils";
import { LOGIN } from "../config/apiConfig";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import { MdOutlineGavel } from "react-icons/md";
import { RiBankCardLine, RiMoneyDollarCircleLine } from "react-icons/ri";
import {
  HiOutlineOfficeBuilding,
  HiShieldCheck,
  HiChartSquareBar,
  HiGlobeAlt,
  HiRefresh,
  HiCheckCircle,
} from "react-icons/hi";
import "./LoginPage.css";
import { BsWhatsapp } from "react-icons/bs";

const FEATURES = [
  {
    title: "Protesto Nacional",
    desc: "Cobertura cartorial ampla",
    icon: MdOutlineGavel,
  },
  {
    title: "Pendências Financeiras",
    desc: "PEFIN, REFIN e mais",
    icon: RiMoneyDollarCircleLine,
  },
  {
    title: "Dados da Receita",
    desc: "CPF/CNPJ, sócios e situação",
    icon: HiOutlineOfficeBuilding,
  },
  {
    title: "Score & Risco",
    desc: "Prob. de atraso e limites",
    icon: HiChartSquareBar,
  },
  {
    title: "Consultas Judiciais",
    desc: "Ações cíveis e trabalhistas",
    icon: HiShieldCheck,
  },
  {
    title: "Cheques sem Fundo",
    desc: "CCF e ocorrências bancárias",
    icon: RiBankCardLine,
  },
];

export default function LoginPage() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (checkIfAuthenticated()) navigate("/dashboard", { replace: true });
  }, [navigate]);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { loading, error, isLoggedIn, login } = useLogin(LOGIN.POST_LOGIN);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const recaptchaToken = await window.grecaptcha.execute(
        "6LeEPpMrAAAAACiEWFXzEAzAulmcTy78Xf5o4VFX",
        { action: "login" }
      );

      await login(email, password, recaptchaToken);

      window.location.replace("/dashboard");
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (isLoggedIn || checkIfAuthenticated()) {
      navigate("/dashboard", { replace: true });
    }
  }, [isLoggedIn, navigate]);
  useEffect(() => {
    if (isLoggedIn) navigate("/dashboard");
  }, [isLoggedIn, navigate]);

  let phoneNumber = null;

  switch (true) {
    case window.location.href.includes("avaliecreditoconsultas"):
      phoneNumber = "4199957643";
      break;
    case window.location.href.includes("proconsultbr"):
      phoneNumber = "15997158996";
      break;
    case window.location.href.includes("obahcredito"):
      phoneNumber = "15997772595";
      break;
    case window.location.href.includes("hellusconsultoria"):
      phoneNumber = "3499502104";
      break;
    case window.location.href.includes("riscocred"):
      phoneNumber = "6141418839";
      break;
    case window.location.href.includes("relinqscore"):
      phoneNumber = "11933579623";
      break;
  }

  let logoSrc;

  switch (true) {
    case window.location.href.includes("avaliecreditoconsultas"):
      logoSrc = "/assets/white-label/avalie-credito/logo.png";
      break;
    case window.location.href.includes("acessopositivo"):
      logoSrc = "/assets/white-label/acesso-positivo/logo-azul.png";
      break;
    case window.location.href.includes("proconsultbr"):
      logoSrc = "/assets/white-label/pro-consult-br/logo_consult.png";
      break;
    case window.location.href.includes("simscore"):
      logoSrc = "/assets/white-label/sim-pesquisa/logo_sim.png";
      break;
    case window.location.href.includes("simpesquisa"):
      logoSrc = "/assets/white-label/sim-pesquisa/logo_sim.png";
      break;
    case window.location.href.includes("credoresbrasil"):
      logoSrc = "/assets/white-label/credores-brasil/logo.png";
      break;
    case window.location.href.includes("consultaspositivo"):
      logoSrc = "/assets/white-label/consultas-positivo/logo.png";
      break;
    case window.location.href.includes("raioxconsultas"):
      logoSrc = "/assets/white-label/raio-x/logo.png";
      break;
    case window.location.href.includes("obahcredito"):
      logoSrc = "/assets/white-label/obah-credito/logo.png";
      break;
    case window.location.href.includes("hellusconsultoria"):
      logoSrc = "/assets/white-label/hellus-consultoria/logo.png";
      break;
    case window.location.href.includes("nomenoazul"):
      logoSrc = "/assets/white-label/nome-no-azul/logo.png";
      break;
    case window.location.href.includes("finposcore"):
      logoSrc = "/assets/white-label/finpo-score/logo.png";
      break;
    case window.location.href.includes("locagora"):
      logoSrc = "/assets/white-label/locagora/logo.png";
      break;
    case window.location.href.includes("riscocred"):
      logoSrc = "/assets/white-label/riscocred/logo.png";
      break;
    default:
      logoSrc = "/assets/relinq_1.png";
      break;
  }

  return (
    <div className="login-page">
      <div className="login-shell">
        <section className="login-brand">
          <div className="brand-hero">
            <h1>Consultas de crédito, cadastrais e veiculares</h1>
          </div>

          <div className="brand-compact">
            <div className="compact-head">
              <span className="compact-kicker">Insights instantâneos</span>
            </div>
            <div className="compact-chart">
              <div className="chart-meta">
                <div>
                  <strong>Score médio</strong>
                  <span>742 pontos</span>
                </div>
                <span className="chart-badge">+12% no mês</span>
              </div>
              <svg
                className="chart-svg"
                viewBox="0 0 240 60"
                aria-hidden="true"
              >
                <path
                  className="chart-area"
                  d="M0 60 L0 50 L40 36 L80 44 L120 24 L160 30 L200 18 L240 28 L240 60 Z"
                />
                <polyline
                  className="chart-line"
                  points="0,50 40,36 80,44 120,24 160,30 200,18 240,28"
                />
                <circle className="chart-dot" cx="40" cy="36" r="3" />
                <circle className="chart-dot" cx="120" cy="24" r="3" />
                <circle className="chart-dot" cx="200" cy="18" r="3" />
              </svg>
              <div className="chart-legend">
                <span>Crédito</span>
                <span>Cadastral</span>
                <span>Veicular</span>
              </div>
            </div>
          </div>

          <div className="brand-feature-grid">
            {FEATURES.map((f) => {
              const Icon = f.icon;
              return (
                <div key={f.title} className="feature-card">
                  <span className="feature-icon">
                    <Icon size={18} />
                  </span>
                  <div>
                    <div className="feature-title">{f.title}</div>
                    <div className="feature-desc">{f.desc}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        <section className="login-panel">
          <div className="mobile-hero">
            <div className="mobile-hero-card">
              <span className="mobile-kicker">Sistema de consultas</span>
              <h3>Crédito, cadastral e veicular</h3>
              <p>Dados confiáveis para decisões rápidas.</p>
            </div>
          </div>
          <div className="panel-frame">
            <div className="panel-top">
              <div className="flex justify-between">
                <div>
                  <h2>Faça seu login</h2>
                </div>
                <img src={logoSrc} alt="Logo" className="h-10" />
              </div>
            </div>

            <form onSubmit={handleSubmit} className="panel-form">
              <label className="input-label" htmlFor="email">
                E-mail ou Código de acesso
              </label>
              <input
                id="email"
                type="text"
                className="input-field"
                placeholder="exemplo@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                required
              />

              <label className="input-label" htmlFor="password">
                Senha
              </label>
              <div className="input-wrap">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  className="input-field"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="input-action"
                  aria-label={showPassword ? "Esconder senha" : "Mostrar senha"}
                >
                  {!showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                </button>
              </div>

              {error && (
                <div className="panel-error">
                  <GoAlertFill size={18} />
                  <span>
                    {error?.response?.data?.message ||
                      "Erro ao tentar fazer login."}
                  </span>
                </div>
              )}

              <Button
                type="submit"
                className="panel-button"
                isProcessing={loading}
                processingSpinner={
                  <AiOutlineLoading className="h-5 w-5 animate-spin" />
                }
                disabled={loading}
              >
                Entrar
              </Button>
            </form>
            {phoneNumber && (
              <a
                className="underline w-fit mx-auto mt-3 text-gray-600 flex gap-2 items-center text-sm "
                href={`https://wa.me/55${phoneNumber}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <BsWhatsapp />
                <span> Falar com especialista</span>
              </a>
            )}

            <p className="panel-legal">Este site e protegido pelo reCAPTCHA</p>
          </div>
        </section>
      </div>
    </div>
  );
}
